/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner } from './card-transactions-merged-transaction-detail-list-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];


